import { VerticalLayout } from "../components/layout"
import { TitleDescription } from "../components/titleDescription"

export const TitleOrder = ({detail}) => {
    return(
        <div className="horizontal space-between">
                <h5 className="card-title">Order #{detail.order_number}</h5>
                <p className="medium-text grey-600">{detail.date}</p>
        </div>
    )
}

export const OrderRow = ({ detail,value, className, style }) => {
    return (
        <div className={`horizontal standard-padding ${className}`} style={{ style, width:"unset" }}>
            <VerticalLayout>
                <p className="card-description">
                    {detail.title}
                </p>
                <p className="card-description-small">
                    {detail.description}
                </p>
            </VerticalLayout>

            <p className={`card-description ${value < 0 && "value-text-active"}`}>€{value},-</p>
        </div>
    )
}